import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
  {
    path: '/',
      component: () => import('@/views/layout/LoginLayout'),
      children: [
        // login
        {
          name: 'Login',
          path: '',
          component: () => import('@/views/login/Login'),
        },
        {
          name: 'Logout',
          path: 'logout',
          component: () => import('@/views/login/Logout'),
        },
      ],
  },
  {
    path: '/view/utility',
        component: () => import('@/views/layout/DashboardLayout'),
        children: [

          {
            name: 'order_status',
            path: 'order_status',
            component: () => import('@/views/utility/OrderStatus'),
          },
          {
            name: 'order_archive',
            path: 'order_archive',
            component: () => import('@/views/utility/OrderArchive'),
          },
          {
            name: 'spareparts_archive',
            path: 'spareparts_archive',
            component: () => import('@/views/utility/SparepartsArchive'),
          },
          {
            name: 'lista_fatture',
            path: 'lista_fatture',
            component: () => import('@/views/utility/ListaFatture'),
          },
          {
            name: 'copia_ddt',
            path: 'copia_ddt',
            component: () => import('@/views/utility/CopiaDdt'),
          },
        ],
  },
  {
  path: '/view',
      component: () => import('@/views/layout/DashboardLayout'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Dashboard
        {
          name: 'Dashboards',
          path: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Blog',
          path: 'blog',
          component: () => import('@/views/dashboard/Blog'),
        },
        {
          name: 'Ordini',
          path: 'ordini',
          component: () => import('@/views/Ordine/Ordini'),
        },
        {
          name: 'Ricambi',
          path: 'ricambi',
          component: () => import('@/views/utility/SparePartsOrder'),
        },
        {
          name: 'Riparazioni',
          path: 'riparazioni',
          component: () => import('@/views/dashboard/Riparazioni'),
        },
        {
          name: 'Raccoltapunti',
          path: 'raccoltapunti',
          component: () => import('@/views/dashboard/Raccoltapunti'),
        },
        {
          name: 'Download',
          path: 'download/:section',
          props: true,
          component: () => import('@/views/dashboard/Download'),
        },
    ],
  },
  {
    path: '/postvendita',
        component: () => import('@/views/layout/DashboardLayout'),
        children: [
          {
            name: 'Riparazioni',
            path: 'riparazioni',
            component: () => import('@/views/dashboard/Riparazioni'),
          },
          {
            name: 'CambiLente',
            path: 'cambilente',
            component: () => import('@/views/dashboard/Riparazioni'),
          },
        ],
  },
  {
    path: '/test',
        component: () => import('@/views/layout/DashboardLayout'),
        children: [
          {
            name: 'FormeBslab',
            path: 'bslab',
            component: () => import('@/views/test/Bslab'),
          },
          {
            name: 'iframeOrdini',
            path: 'iframeordini',
            component: () => import('@/views/test/IframeOrdini'),
          },
        ],
  },
    // {
    //   path: '/view',
    //   component: () => import('@/views/layout/DashboardLayout'),
    //   children: [
    //     // Dashboard
    //     {
    //       name: 'Dashboard',
    //       path: '',
    //       component: () => import('@/views/dashboard/Dashboard'),
    //     },
    //     // Dashboard
    //     {
    //       name: 'Dashboards',
    //       path: 'dashboard',
    //       component: () => import('@/views/dashboard/Dashboard'),
    //     },
    //     // Pages
    //     {
    //       name: 'Clienti',
    //       path: 'pages/clienti',
    //       component: () => import('@/views/dashboard/pages/Clienti'),
    //     },
    //     {
    //       name: 'Ticket',
    //       path: 'pages/ticket',
    //       component: () => import('@/views/dashboard/pages/Ticket'),
    //     },
    //     {
    //       name: 'NewTicket',
    //       path: 'pages/newticket',
    //       component: () => import('@/views/dashboard/pages/NewTicket'),
    //     },
    //     {
    //       name: 'User Profile',
    //       path: 'pages/user',
    //       component: () => import('@/views/dashboard/pages/UserProfile'),
    //     },
    //     {
    //       name: 'Notifications',
    //       path: 'components/notifications',
    //       component: () => import('@/views/dashboard/component/Notifications'),
    //     },
    //     {
    //       name: 'Icons',
    //       path: 'components/icons',
    //       component: () => import('@/views/dashboard/component/Icons'),
    //     },
    //     {
    //       name: 'Typography',
    //       path: 'components/typography',
    //       component: () => import('@/views/dashboard/component/Typography'),
    //     },
    //     // Tables
    //     {
    //       name: 'Regular Tables',
    //       path: 'tables/regular-tables',
    //       component: () => import('@/views/dashboard/tables/RegularTables'),
    //     },
    //     // Maps
    //     {
    //       name: 'Google Maps',
    //       path: 'maps/google-maps',
    //       component: () => import('@/views/dashboard/maps/GoogleMaps'),
    //     },
    //     // Upgrade
    //     {
    //       name: 'Upgrade',
    //       path: 'upgrade',
    //       component: () => import('@/views/dashboard/Upgrade'),
    //     },
    //   ],
    // },
    {
      name: 'PageNotFound',
      path: '*',
      component: () => import('@/views/login/PageNotFound'),
    },
  ],
})

router.beforeEach((to, from, next) => {
   // console.error('controllo autenticazione', store.state.auth)
   console.log('logged', sessionStorage.getItem('logged'))

  console.log('sto arrivando da ' + from.path)
  console.log('Sto andando a ' + to.path)

  if ((!store.state.auth || !sessionStorage.getItem('logged')) && to.path !== '/') {
    console.log('unAuthorized')
    sessionStorage.removeItem('logged')
    next('/')
  } else {
    if (sessionStorage.getItem('logged') && to.path === '/') {
          next('/view/dashboard')
    }
    next()
  }
})

export default router
